export enum InfinityScrollEnum {
    active = 1,
    locked = 2,
    favorite = 3
}
